<template>
  <div class="xiaoqu">
    <div class="bottom">
      <div class="function">
        <p
          style="width:100%;text-align:center"
          v-for="(item, index) in functionList"
          :key="index"
          :class="index == functionValue ? 'active' : ''"
          @click="changeValue(index)"
        >
          {{ item }}
        </p>
      </div>
      <img
        src="../assets/b1.png"
        class="img fadeIn"
        v-show="functionValue == 0"
      />
      <img
        src="../assets/b2.png"
        class="img fadeIn"
        v-show="functionValue == 1"
      />
      <img
        src="../assets/b3.png"
        class="img fadeIn"
        v-show="functionValue == 2"
      />
      <img
        src="../assets/b4.png"
        class="img fadeIn"
        v-show="functionValue == 3"
      />

      <div class="item">
        <p
          v-for="(item, index) in itemList[functionValue]"
          :key="index"
          :class="index == itemValue ? 'active' : ''"
          @click="changeValue2(index)"
        >
          {{ item }}
        </p>
      </div>
    </div>
    <transition name="my">
      <div class="info" v-if="myFlag" v-click-outside="outside">
        <img :src="img" />
        <a href="http://o2vr.net/upload/jiaju-danjian/#/">
          <div class="btn">进入户型</div>
        </a>
      </div>
    </transition>
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside'
export default {
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      functionValue: 1,
      itemValue: 99,
      functionList: ['周边配套', '区位', '漫游', '户型'],
      itemList: [
        ['生活配套', '教育', '交通', '医疗'],
        ['区位图', '配套', '概况'],
        ['鸟瞰3D', '定点漫游'],
        ['8#225㎡', '6-7#151㎡', '10#129㎡']
      ],
      imgList: [
        require('../assets/A.png'),
        require('../assets/B.png'),
        require('../assets/C.png'),
        require('../assets/D.png'),
        require('../assets/E.png')
      ],
      myFlag: false,
      img: ''
    }
  },
  methods: {
    changeValue(e) {
      let _o2 = document.o2
      this.functionValue = e
      this.itemValue = 99
      
      if(e==0){
        document.o2.panel.material.map = document.o2.arrMapTex[0];
        document.o2.panel.scale.set(0,0,0);
        document.o2.switch_camera(-28274,100000,-18890,-28274,126195,-18889);
        let scale = 0;
        let anim = setInterval(() => {
          scale += 0.1;
          if(scale >= 1){
            scale = 1;
            clearInterval(anim);
          }
          document.o2.panel.scale.set(scale,scale,scale);
        }, 30);
      }
      else{
        _o2.switch_camera2(-292, -4684, -242, 15099, 16853, 16262);
      }
      document.o2.panel.visible = (e==0);
    },

    changeValue2(e) {
      this.itemValue = e
      let _o2 = document.o2
      switch (this.functionValue) {
        case 0:
          console.log('周边配套', e)
          document.o2.panel.material.map = document.o2.arrMapTex[parseInt(e)+1];
          break
        case 1:
          this.$router.push({
            name: 'quwei',
            query: {
              id: e
            }
          })
          break
        case 2:
          if (e === 0) {
            this.$router.push({
              name: 'webgl'
            })
          } else {
            this.$router.push({
              name: 'dingdian'
            })
          }
          break
        case 3:
          this.$router.push({
            name: 'room',
            query: {
              id: e
            }
          })
          break
      }
    },

    outside() {
      if (this.myFlag) this.myFlag = false
    }
  },
  mounted() {
    // document.Bus.$on('户型', (e) => {
    //   console.log(e)
    //   if (e) {
    //     this.myFlag = true
    //     this.img = this.imgList[this.itemList[2].indexOf(e)]
    //   }
    // })
  }
}
</script>

<style scoped>
/* .xiaoqu {
  position: fixed;
  top: 0;
  left: 0;
} */
.bottom {
  width: 40%;
  height: 105px;
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  margin: auto;
}
.img {
  width: 100%;
  height: 100%;
  bottom: 0;
  left: 0;
  position: absolute;
}
.function {
  width: 100%;
  position: absolute;
  top: 0;
  z-index: 999;
  display: flex;
  justify-content: space-around;
  font-size: 20px;
  line-height: 40px;
}
.function > p {
  color: #283033;
}
.function > .active {
  color: #fff;
}
.item {
  width: 100%;
  position: absolute;
  bottom: 20%;
  z-index: 999;
  display: flex;
  justify-content: space-around;
}

.item > p {
  width: 120px;
  height: 30px;
  border: 1px solid #fff;
  color: #fff;
  border-radius: 10px;
  text-align: center;
  line-height: 30px;
  font-size: 18px;
}
.item > .active {
  color: #333;
  border: 1px solid #fff;
  background-color: white;
  transition: 0.5s;
}
.info {
  width: 40%;

  position: absolute;
  top: 50px;
  left: 50px;
  transition: 0.5s;
  transform: translateX(0px);
}

.info > img {
  width: 100%;
  opacity: 0.8;
}

.my-enter,
.my-leave-to {
  opacity: 0; /*透明度*/
  transform: translateX(-1000px);
}

.my-enter-active,
.my-leave-active {
  transition: all 0.5s ease;
}

.btn {
  width: 120px;
  height: 50px;
  position: absolute;
  left: 20px;
  bottom: 45px;
  margin: auto;
  border: 1px solid #333;
  line-height: 50px;
  text-align: center;
  border-radius: 25px;
  box-shadow: 3px 3px 3px #333;
  color: #333;
}
@media screen and (max-width: 450px) {
  .bottom {
    width: 100%;
    height: 105px;
  }
  .function {
    font-size: 14px;
    line-height: 30px;
  }
  .item {
    bottom: 25%;
  }
  .item > p {
    width: 60px;
    height: 25px;

    border-radius: 10px;
    text-align: center;
    line-height: 26px;
    font-size: 12px;
  }
  .info {
    width: 100%;

    top: 0px;
    left: 0px;
  }

  .btn {
    width: 80px;
    height: 30px;
    position: absolute;
    left: 10px;
    bottom: 25px;
    margin: auto;
    border: 1px solid #333;
    line-height: 30px;
    font-size: 12px;
    color: #333;
  }
}
</style>
